import React, { useRef } from 'react'
import { useSpring } from 'framer-motion'

import { TooltipProps } from './types'
import * as S from './styles'

const Tooltip = ({
  placement = 'top',
  content,
  children,
  maxWidth,
}: TooltipProps) => {
  const springConfig = useRef({
    damping: 15,
    stiffness: 300,
    ease: 'linear',
  })
  const initialScale = useRef(0.9)

  const opacity = useSpring(0, springConfig.current)
  const scale = useSpring(initialScale.current, springConfig.current)

  const onHide = ({ unmount }) => {
    const cleanup = scale.onChange((value) => {
      if (value <= initialScale.current) {
        cleanup()
        unmount()
      }
    })

    scale.set(initialScale.current)
    opacity.set(0)
  }

  const onMount = () => {
    scale.set(1)
    opacity.set(1)
  }

  if (!content) return <S.Children>{children}</S.Children>

  return (
    <S.Container
      animation
      onHide={onHide}
      onMount={onMount}
      placement={placement}
      render={(attrs) => (
        <S.Tooltip style={{ scale, opacity }} {...attrs}>
          <S.Content style={{ maxWidth: maxWidth ?? 'auto' }}>
            {typeof content === 'function' ? content() : content}
          </S.Content>

          <S.Arrow data-popper-arrow />
        </S.Tooltip>
      )}
    >
      <S.Children>{children}</S.Children>
    </S.Container>
  )
}

export default Tooltip
